export default function BasicCardDocumentos({title, children, style, size} : {title: string, children: any, style?: any, size?:any}){
    const cardClass = `card-title ${size ? `${size}` : ''}`;
    return (
        <div className="otros-documentos-card" style={{...style}}>
            {title &&
            <>
            <div>
                <h3 className={cardClass}>{title}</h3>
            </div>
            <div className="separador"/>
            </>
            }
            {children}
        </div>
    )
}